<div class="max-w-md mx-auto mt-12">

  @if (step=='SIGNIN') {
    <div>
      <form [formGroup]="signInForm" (ngSubmit)="signIn()" >
        <div class="grid grid-cols-1 mt-6">
          @if (requirements.value() && requirements.value()!.emailSuffixes.length) {
            <app-alert type="INFO">
              <p>
                Please sign in with an email address that ends with
                @for (suffix of requirements.value()!.emailSuffixes ; track suffix ; let first = $first ; let last = $last) {
                  @if(!first && !last) {, }
                    @if (!first && last) { or }
                      <strong>...{{suffix}}</strong>
                      } to proceed.    
               
                </p>
                </app-alert>
              }
                <p>
                  Please enter your email address
                </p>
                <mat-form-field color="primary" class="example-full-width">
                  <mat-label>Email</mat-label>
                  <input matInput type="email" pInputText formControlName="email" id="email" required/>
                </mat-form-field>
                <button mat-flat-button color="primary" type="submit" [disabled]="signInForm.invalid">
                  Continue
                </button>
              </div>
            </form>
          </div>
        }

        @if (step=='CONFIRM_SIGNIN') {
          <div>
            <form [formGroup]="confirmForm" (ngSubmit)="confirmSignIn()" >
              <div class="grid grid-cols-1 mt-6">
                <p>
                  A one-time code has been emailed to you. Please enter it below to sign in.
                </p>
                <mat-form-field color="primary" class="example-full-width">
                  <mat-label>Code</mat-label>
                  <input matInput type="text" pInputText formControlName="code" id="email" required/>
                  @if (confirmForm.get('code')!.hasError('invalidCode')) {
                    <mat-error>
                      Invalid code. Please try again.
                    </mat-error>
                  }
                </mat-form-field>
                <button mat-flat-button color="primary" type="submit" [disabled]="confirmForm.invalid">
                  Continue
                </button>
              </div>
            </form>
          </div>
        }

        @if (step=='SIGNUP') {
          <div>
            <form [formGroup]="signUpForm" (ngSubmit)="signUp()" >
              <div class="grid grid-cols-1 mt-6">
                <p>
                  We don't have an account for <strong>{{email}}</strong>. Please enter your details to create one.
                </p>
                <mat-form-field color="primary" class="example-full-width">
                  <mat-label>Given Name</mat-label>
                  <input matInput type="text"  formControlName="givenName" id="email" required/>
                </mat-form-field>
                <mat-form-field color="primary" class="example-full-width">
                  <mat-label>Family Name</mat-label>
                  <input matInput type="text" formControlName="familyName" id="email" required/>
                </mat-form-field>
                <button mat-flat-button color="primary" type="submit" [disabled]="signUpForm.invalid">
                  Sign Up
                </button>
              </div>
            </form>
          </div>
        }

      </div>